import React from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import ReactHtmlParser from 'react-html-parser'
import { MainSlide } from './Content'
import {setHTML} from '../helpers/helpers'

export const SlideBlock = (props) => {
    const slideClass = cn('cell small-12', {'medium-9 large-8 xlarge-6 xxlarge-5':props.center})
    return (
        <MainSlide center={props.center}>
            <div className={slideClass}>
                <div className="content-wrap">
                    <div className='block'>
                        {props.preTitle && <h6>{ ReactHtmlParser(props.preTitle) }</h6>}
                        {props.title && <h1>{ ReactHtmlParser(props.title) }</h1>}
                        {props.text && <div className="text">{ setHTML(props.text) }</div>}
                    </div>
                    {props.customAction && props.center &&
                        <div className="action" onClick={props.onClick}>
                            <Link to={`${props.customAction}`} className="button">{ReactHtmlParser(props.actionText)}</Link>
                        </div>}
                </div>
            </div>
            {!props.center && <div className="cell small-12">
                <div className="action" onClick={props.onClick}>
                    {props.toNext && <div className="text">{props.actionText}</div>}
                    {props.toNext && <div className="arrow"><i className="material-icons">keyboard_arrow_down</i></div>}
                </div>
            </div>}
            {props.children}
        </MainSlide>
    )
}

export const More = (props) =>
    <div className="action scrolldown" onClick={props.onClick}>
        <div className="text">{ReactHtmlParser(props.text)}</div>
        <div className="arrow"><i className="material-icons">keyboard_arrow_down</i></div>
    </div>

export const QuoteBox = (props) =>
    <div className="quote-box">
        <blockquote>
            {ReactHtmlParser(props.text)}
            <cite>{ReactHtmlParser(props.author)}</cite>
        </blockquote>
    </div>

export const Box = (props) => {
    const boxClass = cn('block', props.color) 
    return <div className={boxClass}>{ReactHtmlParser(props.text)}</div>
}



// WEBPACK FOOTER //
// ./src/components/Blocks.js